<template>
  <div :loading="loading">
    <el-select :key="key" v-model="id"
               v-on="$listeners"
               v-bind="$attrs"
               @change="selected"
               filterable
               :multiple="multiple"
               clearable>
      <el-option-group :label="`可选(${options?options.length:0})`">
        <el-option v-for="(item, index) in options" :key="index" :label="item.name"
                   :value="item.id"/>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
import {getUserByRole} from "@/api/user";

export default {
  name: "UserRoleSelect",
  props: {
    roleName: {
      type: String
    },
    userId: {
      type: [String, Number, Array],
      default() {
        return 0
      }
    },
    multiple: Boolean,
  },
  computed: {
    id: {
      get() {
        return this.userId
      },
      set(val) {
        this.$emit('update:userId', val)
      }
    }
  },
  data() {
    return {
      key: (new Date().getTime()),
      options: [],
      loading: false
    }
  },
  methods: {
    async getUserOptionsByRoleName() {
      this.loading = true
      if (this.options.length === 0) {
        const res = await getUserByRole({name: this.roleName})
        const {role} = res.model
        this.options = role || []
        this.key = (new Date().getTime())
      }

      this.loading = false
    },
    selected(val) {
      const _this = this
      let option = null
      if (Array.isArray(val)) {
        option = []
        val.map(_ => {
          option.push(_this.options.find(value => value.id === _))
        })
      } else {
        option = _this.options.find(value => value.id === val)
      }

      this.$emit('selected', option, this.roleName)
    }
  },
  created() {
    this.getUserOptionsByRoleName()
  }
}
</script>

<style scoped>

</style>